import { render, staticRenderFns } from "./coderInpatientAdvancedView.vue?vue&type=template&id=448ebc04&scoped=true&"
import script from "./coderInpatientAdvancedView.vue?vue&type=script&lang=js&"
export * from "./coderInpatientAdvancedView.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientAdvancedView.vue?vue&type=style&index=0&id=448ebc04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448ebc04",
  null
  
)

export default component.exports